import { gql } from 'apollo-boost';

export const CREATE_BUSINESS = gql`
  mutation BusinessCreate($input: BusinessCreateInput!) {
    business_create(input: $input) {
      business {
        id
        name
        street_1
        street_2
        city
        state
        zip
        url
        phone_number
        business_features {
          auditions
          bookings
          audition_limits {
            applications_max
            duration_max
          }
        }
        hours_of_operation {
          id
          all_day
          closed
          close
          open
        }

        organization {
          id
        }
        active
        allow_dancer_reviews
        allow_under_21_dancers
        number_of_stages
        square_footage
        max_consecutive_shift_count
        min_dancers_for_free_agent_search
        free_agent_search_enabled
        dancer_count
        profile_options {
          id
          name
          trans_key
        }
        required_documents
        special_requirements
        special_requirements_link

        audition_info
        notes
        tier
        auditions_enabled
        message_club
        audition_duration_max
        audition_applications_max
      }
    }
  }
`;
